import {Inject, Injectable, PLATFORM_ID} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {isPlatformBrowser} from "@angular/common";
import {LOCAL_STORAGE, WINDOW} from "@ng-toolkit/universal";
import {FoEventsService} from "./event/foevents.service";
import {AuthService} from "../core/auth/auth.service";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class FonctionUtiles {
  constructor(private http: HttpClient, private translate: TranslateService,
              @Inject(WINDOW) private window: Window,
              @Inject(LOCAL_STORAGE) private localStorage: any,
              @Inject(PLATFORM_ID) private platformId: Object,
              private eventservice: FoEventsService,
              private authservice: AuthService) {}

  perPagePagination:number = 25;
  currencyMap: any = {'eur': '€', 'usd': '$'};
  LangFr = 'fr';
  LangEN = 'en';
  LangFlagFR = 'assets/imgs/france.png';
  LangFlagEN = 'assets/imgs/united-kingdom.png';
  languageFlagMap: any = {'fr': 'assets/imgs/france.png', 'en': 'assets/imgs/united-kingdom.png'};

  getPricingDeviseSymbole(devise) {
    if (devise)
      return this.currencyMap[devise.toLowerCase()]
  }


  eventType(event) {
    if(event.has_ticketing) {
      return 'Billetterie';
    }
    if(event.has_registration_module) {
      return 'Inscription';
    }
    if(event.has_open_ticketing) {
      return 'Cagnotte';
    }
  }

  currencyValues = {
    'eur': {
      f1: 40,
      f2: 9.99,
      f3: 0.99
    },
    'usd': {
      f1: 44.85,
      f2: 11.20,
      f3: 1.12
    }
  };


  useLanguage(language: string, e) {
    e.preventDefault();
    this.translate.use(language);
    this.store('curentLang', language);
    this.store('curentLangFlag', this.languageFlagMap[language.toLowerCase()]);
    if (this.authservice.hasValidToken()) {
      let user = this.authservice.getUser();
      user.lang = language;
      this.eventservice.updateUserLang(user).then(res => {
      /*  window.location.reload()*/
      })
    }
    else {
     /* window.location.reload();*/
    }
  }


  store(key, value): Promise<any> {
    if (isPlatformBrowser(this.platformId)) {
      try {
        localStorage.setItem(key, JSON.stringify(value));
        return;
      } catch (e) {
        console.log("localStorage not available");
        return null;
      }
    }
  }

  retrieve(key) {
    if (isPlatformBrowser(this.platformId)) {
      try {
        let value = localStorage.getItem(key);
        return JSON.parse(value);
      } catch (e) {
        console.log("localStorage not available");
        return null;
      }
    }
  }

  calculOrganizerFrais(tickets, event) {
    let cur = (event.currency && event.currency != 'selectionnez') ? event.currency.toLowerCase() : 'eur';
    // console.log(cur)
    let frais: number = 0;
    for (let i = 0; i < tickets.length; i++) {
      if (this.ticketHasOrderAndIsPaid(tickets[i])) {
        if (this.getPricingPrice(tickets[i].pricing) >= this.currencyValues[cur].f1) {
          let a = this.getPricingPrice(tickets[i].pricing) * 2.5 / 100;
          if (a <= this.currencyValues[cur].f2)
            frais += ((this.getPricingPrice(tickets[i].pricing) * 2.5 / 100));
          else
            frais += ((this.currencyValues[cur].f2));
        } else if (this.getPricingPrice(tickets[i].pricing) < this.currencyValues[cur].f1 && this.getPricingPrice(tickets[i].pricing) > 0)
          frais += this.currencyValues[cur].f3;
        else if (this.getPricingPrice(tickets[i].pricing) == 0)
          frais += 0;
      }
    }
    return frais;
  }

  getPricingPrice(pricing) {
    if (parseInt(pricing.isFeeIncluded) == 0) {
      return pricing.Totalprice;
    }
    return pricing.price;
  }

  //status belongs to order deleted or not
  ticketHasOrderAndIsPaid(ticket) {
    return ticket.order_id && ticket.order && !ticket.isPromo && ticket.order.state && ticket.pricing && !ticket.statut && !ticket.refund
  }

  OrderAndIsPaid(order) {
    return order.state
  }

  ticketHasOrder(ticket) {
    return ticket.order_id && ticket.order && !ticket.isPromo && ticket.pricing && !ticket.statut
  }


  ticketHasOrderAndIsPaidandPromo(ticket) {
    return ticket.order_id && ticket.order && ticket.order.state && ticket.pricing && !ticket.statut && !ticket.refund
  }

  ticketHasOrderAndIsPaidandPromoAndRefunded(ticket) {
    return ticket.order_id && ticket.order && ticket.order.state && ticket.pricing && ticket.refund
  }

  //aa
  calculOrganizerRecette(tickets) {
    let total: number = 0;
    for (let i = 0; i < tickets.length; i++) {
      if (this.ticketHasOrderAndIsPaid(tickets[i])) {
        total += parseFloat(tickets[i].pricing.price);
        if (tickets[i].reduction) {
          total -= tickets[i].reduction;
        }
      }
    }
    return total;
  }

  restTopay(deadlines) {
    let total: number = 0;
    for (let i = 0; i < deadlines.length; i++) {
      if (deadlines[i].order.state && !deadlines[i].payed) {
        total += parseFloat(deadlines[i].amount);
      }
    }
    return total;
  }

  calculOrganizerRecetteByOrder(orders) {
    let total: number = 0;
    for (let i = 0; i < orders.length; i++) {
      if (this.OrderAndIsPaid(orders[i])) {
        total += parseFloat(orders[i].total_price);
      }
    }
    return total;
  }

  currenCyIsUsd(event) {
    return event.currency === 'USD';
  }

  showTotal(event, total) {
    return this.currenCyIsUsd(event)? total * 0.92: total
  }





  slugify(string) {
    return string
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[éèêë]/g, "e")
      .replace(/\s+/g, "-")
      .replace(/[^\w\-]+/g, "")
      .replace(/\-\-+/g, "-")
      .replace(/^-+/, "")
      .replace(/-+$/, "");
  }


  filtrerValidTicketsAndPromo(tickets) {
    let tmp = [];
    for (let i = 0; i < tickets.length; i++) {
      if (this.ticketHasOrderAndIsPaidandPromo(tickets[i]) || !tickets[i].order_id && !tickets[i].statut && !tickets[i].refund) {
        tmp.push(tickets[i]);
      }
    }
    return tmp;
  }


  filtrerRefundedTickets(tickets) {
    let tmp = [];
    for (let i = 0; i < tickets.length; i++) {
      if (this.ticketHasOrderAndIsPaidandPromoAndRefunded(tickets[i]) || !tickets[i].order_id && tickets[i].refund) {
        tmp.push(tickets[i]);
      }
    }
    return tmp;
  }


  filtrerValidTickets(tickets) {
    let tmp = [];
    for (let i = 0; i < tickets.length; i++) {
      if (this.ticketHasOrderAndIsPaid(tickets[i]) || !tickets[i].order_id && !tickets[i].statut) {
        tmp.push(tickets[i]);
      }
    }
    return tmp;
  }


  /* calculatePricingPriceAfterPromoApply(pricing) {
     if (pricing.codePromo && pricing.codePromo.reduction_simple)
       return this.getPricingPrice(pricing) - pricing.codePromo.reduction_simple;
     else if (pricing.codePromo && pricing.codePromo.reduction_by_percentage)
       return this.getPricingPrice(pricing) - (this.getPricingPrice(pricing) * pricing.codePromo.reduction_by_percentage / 100);
   }*/

  calculatePricingPriceAfterPromoApply(pricing) {
    if (pricing.codePromo && pricing.codePromo.reduction_simple)
      return this.getPricingPrice(pricing) - pricing.codePromo.reduction_simple;
    else if (pricing.codePromo && pricing.codePromo.reduction_by_percentage)
      return this.getPricingPrice(pricing) - (this.getPricingPrice(pricing) * pricing.codePromo.reduction_by_percentage / 100);
    else if (pricing.codePromo && pricing.codePromo.reduction_type == "Gratuit")
      return 0;
    else
      return 0;
  }


  getPricingTotal(pricing) {
    if (pricing.codePromo)
      return this.calculatePricingPriceAfterPromoApply(pricing);
    else
      return this.getPricingPrice(pricing);
  }


  /* CodePRomoReduction(pricing)
   {
     if(pricing.codePromo && pricing.codePromo.reduction_simple )
       return  pricing.codePromo.reduction_simple;
     else if(pricing.codePromo && pricing.codePromo.reduction_by_percentage )
       return (this.getPricingPrice(pricing)* pricing.codePromo.reduction_by_percentage/100);
   }*/


  filtrersales(tickets) {
    let tmp = [];
    for (let i = 0; i < tickets.length; i++) {
      if (this.ticketHasOrderAndIsPaid(tickets[i])) {
        tmp.push(tickets[i]);
      }
    }
    return tmp.length;
  }


  displayMessages() {
    if (isPlatformBrowser(this.platformId)) {
      try {
        window.scrollTo(0, 0);
        return;
      } catch (e) {
        console.log("localStorage not available");
        return null;
      }
    }
  }


  eventIsEnd(event) {
    let c = new Date();
    let closed = (event.end_date + ' ' + event.end_hour)
    let dClosed = new Date(closed.replace(/ /g, "T"));
    if (dClosed.getTime() - c.getTime() <= 0) {
      return true;
    }
    else {
      return false;
    }
  }


  eventHasTicketing(event) {
    return event.has_ticketing || event.has_open_ticketing || event.has_registration_module;
  }

  codePromoReduct(pricing) {

    if (pricing.codePromo && pricing.codePromo.reduction_simple)
      return parseFloat(pricing.codePromo.reduction_simple);
    else if (pricing.codePromo && pricing.codePromo.reduction_by_percentage)
      return (this.getPricingPrice(pricing) * parseFloat(pricing.codePromo.reduction_by_percentage) / 100);
    else if (pricing.codePromo && pricing.codePromo.reduction_type == "Gratuit")
      return this.getPricingPrice(pricing);
    else
      return 0;

  }

  CodePRomoReduction(pricing, event) {

    let reduction: number = 0;
    reduction += this.codePromoReduct(pricing);
    if (event.codepromos) {
      for (let i = 0; i < event.codepromos.length; i++) {
        if (event.codepromos[i].reduction_simple) {
          //reduction on order is done on a pricing total only one time
          reduction += event.codepromos[i].reduction_simple;
        }
        else {
          // percentengage reduction on total order is sum of all pricing total percentage reduction
          reduction += (this.getPricingPrice(pricing) * event.codepromos[i].reduction_by_percentage) / 100;
        }
      }
    }
    return reduction;
  }


  pricingReduction(pricing) {
    let reduction: number = 0;
    reduction += this.codePromoReduct(pricing);
    if(pricing.codePromo && pricing.codePromo.can_be_used_several_times) {
      return reduction * pricing.nbreTicket;
    } else {
      return reduction;
    }
  }


  calculSelectedPricingNumber(prcings) {
    let nbr = 0;
    for (let i = 0; i < prcings.length; i++) {
      if (this.getPricingPrice(prcings[i]) && prcings[i].nbreTicket > 0) {
        nbr++;
      }
    }
    return nbr;
  }


  calculTicketsSelectedNumber(prcings) {
    let nbr = 0;
    for (let i = 0; i < prcings.length; i++) {
      if (this.getPricingPrice(prcings[i]) && prcings[i].nbreTicket > 0) {
        nbr += prcings[i].nbreTicket;
      }
    }
    return nbr;
  }

  orderReductionByPricing(pricing, eventCodePRomos, pricings) {
    let reduction: number = 0;
    if (eventCodePRomos && eventCodePRomos.length > 0) {
      //répartir toutes les promostions lié a la commande sur chaque tarif quand il s'agit d'une reduction en pourcentage
      //s'il s'agit d'une reduction simple on reduit le premier tarif en une fois
      for (let i = 0; i < eventCodePRomos.length; i++) {
        //cette condition check que c'est pas un code lié au pricing
        if(!eventCodePRomos[i].pricing) {
          if (eventCodePRomos[i].reduction_simple) {
            //répartir les reduction sur toutes les tickets
            reduction += eventCodePRomos[i].reduction_simple / this.calculSelectedPricingNumber(pricings);
          }
          else {
            // percentengage reduction on total order is sum of all pricing total percentage reduction
            reduction += (this.getPricingPrice(pricing) * eventCodePRomos[i].reduction_by_percentage) / 100;
          }
        }
      }
    }
    return reduction;
  }

  calculateshowTotalPrice(order) {
    let total = 0;
    if(order.deadlines.length ==0){
      total = order.total_price;
    } else {
      for(let j=0;j<order.deadlines.length;j++) {
        total+= order.deadlines[j].amount;
      }
    }
    return total;
  }

  calculOptionsFee(optionTotal, currency) {
    let cur = currency ? currency.toLowerCase() : 'eur';
    let frais = 0;
    if (optionTotal >= this.currencyValues[cur].f1) {
      let a = optionTotal * 2.5 / 100;
      if (a <= this.currencyValues[cur].f2)
        frais += optionTotal * 2.5 / 100;
      else
        frais += this.currencyValues[cur].f2;
    }
    else if (optionTotal < this.currencyValues[cur].f1 && optionTotal > 0)
      frais += this.currencyValues[cur].f3;
    else if (optionTotal == 0)
      frais += 0;

    return frais;
  }


  globalFee(fee,total) {
    console.log(total);
    if(total === Number(0).toFixed(2)) {
      return 0;
    }
    return fee;
  }


  calculFrais1(pricings, currency) {
    let cur = currency ? currency.toLowerCase() : 'eur';
    let frais = 0;
    for (let i = 0; i < pricings.length; i++) {
      if (pricings[i].isFeeIncluded) {
        if (pricings[i].codePromo && pricings[i].codePromo.reduction_type == "Gratuit") {
          //si promotion gratuite un code promo ne sera pas pris en compte pour les frais
          console.log('ok pricing grtatuit');
          if (this.getPricingPrice(pricings[i]) >= this.currencyValues[cur].f1) {
            let a = this.getPricingPrice(pricings[i]) * 2.5 / 100;
            if (a <= this.currencyValues[cur].f2)
              frais += ((parseFloat(pricings[i].nbreTicket) - 1) * (this.getPricingPrice(pricings[i]) * 2.5 / 100));
            else
              frais += ((parseFloat(pricings[i].nbreTicket) - 1) * (this.currencyValues[cur].f2));
          }
          else if (this.getPricingPrice(pricings[i]) < this.currencyValues[cur].f1 && this.getPricingPrice(pricings[i]) > 0)
            frais += (parseFloat(pricings[i].nbreTicket) - 1) * this.currencyValues[cur].f3;
          else if (this.getPricingPrice(pricings[i]) == 0)
            frais += 0;
        } else {
          if (this.getPricingPrice(pricings[i]) >= this.currencyValues[cur].f1) {
            let a = this.getPricingPrice(pricings[i]) * 2.5 / 100;
            if (a <= this.currencyValues[cur].f2)
              frais += (parseFloat(pricings[i].nbreTicket) * (this.getPricingPrice(pricings[i]) * 2.5 / 100));
            else
              frais += (parseFloat(pricings[i].nbreTicket) * (this.currencyValues[cur].f2));
          }
          else if (this.getPricingPrice(pricings[i]) < this.currencyValues[cur].f1 && this.getPricingPrice(pricings[i]) > 0)
            frais += parseFloat(pricings[i].nbreTicket) * this.currencyValues[cur].f3;
          else if (this.getPricingPrice(pricings[i]) == 0)
            frais += 0;
        }
      }
      else {
        frais += (parseFloat(pricings[i].nbreTicket) * pricings[i].fee)
      }
    }
    return frais;
  }


  calculFrais(pricings, currency) {
    let cur = currency ? currency.toLowerCase() : 'eur';
    let frais = 0;
    for (let i = 0; i < pricings.length; i++) {
      if (pricings[i].isFeeIncluded) {
        if (pricings[i].codePromo && pricings[i].codePromo.reduction_type == "Gratuit") {
          //si promotion gratuite un code promo ne sera pas pris en compte pour les frais
          console.log('ok pricing grtatuit');
          if (this.getPricingPrice(pricings[i]) >= this.currencyValues[cur].f1) {
            let a = this.getPricingPrice(pricings[i]) * 2.5 / 100;
            if (a <= this.currencyValues[cur].f2)
              frais += ((parseFloat(pricings[i].nbreTicket) - 1) * (this.getPricingPrice(pricings[i]) * 2.5 / 100));
            else
              frais += ((parseFloat(pricings[i].nbreTicket) - 1) * (this.currencyValues[cur].f2));
          }
          else if (this.getPricingPrice(pricings[i]) < this.currencyValues[cur].f1 && this.getPricingPrice(pricings[i]) > 0)
            frais += (parseFloat(pricings[i].nbreTicket) - 1) * this.currencyValues[cur].f3;
          else if (this.getPricingPrice(pricings[i]) == 0)
            frais += 0;
        } else {
          if (this.getPricingPrice(pricings[i]) >= this.currencyValues[cur].f1) {
            let a = this.getPricingPrice(pricings[i]) * 2.5 / 100;
            if (a <= this.currencyValues[cur].f2)
              frais += (parseFloat(pricings[i].nbreTicket) * (this.getPricingPrice(pricings[i]) * 2.5 / 100));
            else
              frais += (parseFloat(pricings[i].nbreTicket) * (this.currencyValues[cur].f2));
          }
          else if (this.getPricingPrice(pricings[i]) < this.currencyValues[cur].f1 && this.getPricingPrice(pricings[i]) > 0)
            frais += parseFloat(pricings[i].nbreTicket) * this.currencyValues[cur].f3;
          else if (this.getPricingPrice(pricings[i]) == 0)
            frais += 0;
        }
      } else {

      }
    }
    return frais;
  }


  //pricing acreditation form
  calculateTotalPriceWhenComNotIncluded(price, pricing, currency) {
    let cur = currency ? currency.toLowerCase() : 'eur';
    if (price >= this.currencyValues[cur].f1) {
      let a = price * 2.5 / 100;
      if (a <= this.currencyValues[cur].f2) {
        pricing.Totalprice = price + price * 2.5 / 100;
        pricing.price = price;
        pricing.fee = price * 2.5 / 100;
      } else {
        pricing.price = price;
        pricing.Totalprice = price + this.currencyValues[cur].f2;
        pricing.fee = this.currencyValues[cur].f2;
      }
    } else if (price < this.currencyValues[cur].f1 && price > 0) {
      pricing.price = price;
      pricing.Totalprice = price + this.currencyValues[cur].f3;
      pricing.fee = this.currencyValues[cur].f3;
    } else if (price == 0) {
      pricing.price = 0;
      pricing.Totalprice = 0;
      pricing.fee = 0;
    }
  }


  //pricing acreditation form
  calculateTotalPriceWhenComIncluded(price, pricing, currency) {
    let cur = currency ? currency.toLowerCase() : 'eur';
    let fee;
    if (price >= this.currencyValues[cur].f1) {
      let a = price * 2.5 / 100;
      if (a <= this.currencyValues[cur].f2) {
        pricing.Totalprice = price;
        pricing.price = price - price * 2.5 / 100;
        pricing.fee = price * 2.5 / 100;
      }
      else {
        pricing.price = price - this.currencyValues[cur].f2;
        pricing.Totalprice = price;
        pricing.fee = this.currencyValues[cur].f2
      }
    }
    else if (price < this.currencyValues[cur].f1 && price > 0) {
      pricing.price = price - this.currencyValues[cur].f3;
      pricing.Totalprice = price;
      pricing.fee = this.currencyValues[cur].f3;
    }
    else if (price == 0) {
      pricing.price = 0;
      pricing.Totalprice = 0;
      pricing.fee = 0;
    }
  }
  isOrga(user) {
    return (user.events.length > 0 || user.isOrga || user.organisation.id != 2)
  }

  getOrgaList(users) {
    let orgas = [];
    for(let i=0;i<users.length;i++) {
      if(this.isOrga(users[i])) {
        orgas.push(users[i]);
      }
    }
    return orgas;
  }
  getUserList(users) {
    let users1 = [];
    for(let i=0;i<users.length;i++) {
      if(!this.isOrga(users[i])) {
        users1.push(users[i]);
      }
    }
    return users1;
  }

  calculateOptionTotal(order) {
    let optiontotal = 0;
    for(let i = 0 ;i<order.tickets.length; i++){
      //console.log(this.order.tickets[i].options);
      for(let j=0;j<order.tickets[i].options.length;j++){
        //console.log(this.order.tickets[i].options);
        optiontotal += order.tickets[i].options[j].price
      }
      /* if(this.order.tickets[i].form.inputsTicket && this.order.tickets[i].form.inputsTicket.length >0) {
         for(let j=0;j<this.order.tickets[i].form.inputsTicket.length;j++){
           if(this.order.tickets[i].form.inputsTicket[j].options){
             //console.log(this.order.tickets[i]);
             for(let k = 0;k<this.order.tickets[i].form.inputsTicket[j].options.length;k++){
               optiontotal += this.order.tickets[i].form.inputsTicket[j].options[k].price
             }
           }
         }
       }*/
    }
    //console.log('options '+optiontotal);
    return optiontotal;
  }

  calculTotal(pricings,codepromos?) {
    let total = 0;
    let nbreTicket = 0;
    for (let i = 0; i < pricings.length; i++) {
      if (pricings[i].price && pricings[i].nbreTicket)
        if (!pricings[i].open)
          total += pricings[i].nbreTicket * this.getPricingPrice(pricings[i]) - this.pricingReduction(pricings[i]) - this.orderReductionByPricing(pricings[i], codepromos, pricings);
        else
          total += this.getPricingPrice(pricings[i]) - this.pricingReduction(pricings[i]) - this.orderReductionByPricing(pricings[i], codepromos, pricings);
    }
    return total.toFixed(2);
  }

  getInitials(string) {
    let names = string.split(' '),
      initials = names[0].substring(0,1).toUpperCase();

    if(names.length > 1) {
      initials+= names[names.length-1].substring(0,1).toUpperCase();
    }

    return initials;
  }
  userIsMale(user) {
    return !user.gender || user.gender === 1
  }
  orgaIsValidated(organisation) {
   return  organisation && organisation.id != 2  &&  organisation.payment &&  organisation.payment.id && organisation.payment.id > 0 && organisation.payment.bic && organisation.payment.iban
  }

  userGetOrganisation(row) {
    return row.user && row.user.organisation && row.user.organisation.name && row.user.organisation.id != 2
  }

  claculSymbol(event) {
    if (event.currency && event.currency.toLowerCase() == 'eur') {
      return ' e';
    }
    else if (event.currency) {
      return ' u';
    }
  }

  currencySymbol(event) {
    if (event.currency && event.currency.toLowerCase() == 'eur') {
      return ' €';
    } else if (event.currency === 'usd') {
      return ' $';
    }
  }

  makePagination(rows) {
    let nb = Math.floor((rows.length/this.perPagePagination)+1);
    let nbpage: any = [];
    for(let i = 0; i < nb; i++) {
      nbpage.push(i);
    }
    let paginatedRows = this.paginate(0,rows);
    return { 'rows': paginatedRows, 'nbpage': nbpage, 'emptyMessage': {
        emptyMessage: 'Aucun participant enregistré',
        totalMessage: 'total'
      }}
  }

  paginate(page,arr) {
    return arr.slice(page*this.perPagePagination,(page +1)*this.perPagePagination);
  }

  filtrer(tickets) {
    //console.log("ticks ", tickets.length);
    let tmp = [];
    for (let i = 0; i < tickets.length; i++) {
      if ((tickets[i].order_id && tickets[i].order && tickets[i].order.state == 1 && !tickets[i].statut) || !tickets[i].order_id && !tickets[i].statut || new Date(tickets[i].created_at) <= new Date('2018-06-12') && !tickets[i].statut) {
        tmp.push(tickets[i]);
      }
    }
    return tmp;
  }


}

